var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMcp = function SvgMcp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 195 195"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 12,
    d: "M25 97.853 92.882 29.97c9.373-9.373 24.569-9.373 33.941 0v0c9.373 9.372 9.373 24.568 0 33.94l-51.265 51.266M76.265 114.47l50.558-50.558c9.373-9.373 24.569-9.373 33.942 0l.353.353c9.373 9.373 9.373 24.569 0 33.941L99.725 159.6a8 8 0 0 0 0 11.313l12.606 12.607"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 12,
    d: "M109.853 46.941 59.648 97.146c-9.372 9.372-9.372 24.568 0 33.941v0c9.373 9.372 24.569 9.372 33.941 0l50.205-50.205"
  })));
};
export default SvgMcp;